<template>
  <div class="container">
    <div class="col-md-12">
      <h1>Live Trading Room Recordings</h1>       
    </div>    
    <FrameView url="https://www.tradespoon.com/members/ytltr.php" title="Live Trading Room Recordings" :height="600"></FrameView>
  </div>
</template>

<script>
import FrameView from "../../components/FrameView.vue";

export default {
    name:'LiveTradingRoomRecordingsPage',
    components: { FrameView }    
}
</script>
<style scoped>
    .iframe-recordings {
        border: 0;
        width: 100%;
        height: 500px;
    }
</style>